import React, { useContext } from "react";
import SubItemsAjax from "./SubItemsAjax";
import GlobalsContext from "../../context/GlobalsContext";

const GeoItems = props => {
  const globalsContext = useContext(GlobalsContext);

  return <SubItemsAjax {...props} options={globalsContext.geos} />;
};

export default GeoItems;
